// 获取地球上两坐标点的距离（ps：将地球看做光滑球体）
import * as utility from 'utility';
import axios from "axios/index";
const EARTH_RADIUS = 6378137.0; // 单位M
const PI = Math.PI;

export const index = {
  //检验邮箱
  checkEmail(str){
    let re = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
    if(re.test(str)){
      return true
    }else{
      return false
    }
  },
  //检验手机号码
  checkPhoneNumber(tel){
    let reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
    if(reg.test(tel)){
      return true
    }
    return false
  },
// 评论常用时间术语
  handleTimeDesc(post_modified) {
    let $text = '';
    const curTime = new Date();
    const postTime = new Date(post_modified);
    const timeDiff = Math.floor((curTime.getTime() - postTime.getTime()) / 1000);
    if (utility.YYYYMMDD(curTime) === utility.YYYYMMDD(postTime)) {
      if (timeDiff < 60) {
        $text = '刚刚'; // 一分钟内
      } else if (timeDiff < 60 * 60) {
        $text = Math.floor(timeDiff / 60) + '分钟前'; // 一小时内
      } else if (timeDiff < 60 * 60 * 24) {
        $text = Math.floor(timeDiff / (60 * 60)) + '小时' + Math.floor(timeDiff % (60 * 60) / 60) + '分钟前'; // 一天内
      }
    } else if (timeDiff < 60 * 60 * 24 * 30) {
      $text = utility.YYYYMMDD(postTime);
    }
    return $text;
  },
  /**
   *
   * @param val
   * @returns {string}
   */
  moneyFormat(val) {
    // 金额转换 分->元 保留2位小数 并每隔3位用逗号分开 1,234.56
    const str = (val * 100 / 100).toFixed(2) + '';
    const intSum = str.substring(0, str.indexOf('.')).replace(/\B(?=(?:\d{3})+$)/g, ',');// 取到整数部分
    const dot = str.substring(str.length, str.indexOf('.'));// 取到小数部分搜索
    return intSum + dot;
  },
  /**
   * 日期转字符串
   * @param {any} date
   */
  dateToString(date, type = 0) {
    if (this.isString(date)) {
      date = this.string2date(date);
    }
    if (this.isDate(date)) {
      const _year = date.getFullYear();
      const _month = date.getMonth() + 1;
      const _date = date.getDate();
      let str = '';
      switch (type) {
      case 0:
        str = _year +
            (_month > 9 ? '-' : '-0') +
            _month +
            (_date > 9 ? '-' : '-0') +
            _date;
        break;
      case 1:
        str = `${_year}年${_month > 9 ? _month : '0' + _month}月${_date > 9 ? _date : '0' + _date}日`;
        break;
      default:
        break;
      }
      return str;
    } else {
      throw '传入参数date有误';
    }
  },

  /**
   * 字符串转日期
   * @param {any} str
   */
  string2date(str) {
    return new Date(Date.parse(str.replace(/-/g, '/')));
  },

  /**
   *
   * @param {any} strObj 待替换字符对象
   * @param {any} pos 起始位置 从0开始
   * @param {any} length 长度
   * @param {any} replacetext 替换的文字
   */
  replacePosLength(strObj, pos, length, replacetext) {
    var str =
      strObj.substr(0, pos) +
      replacetext +
      strObj.substring(pos + length, strObj.length);
    return str;
  },

  // 获取地球上两坐标点的距离（ps：将地球看做光滑球体）
  getRad(d) {
    return (d * PI) / 180.0;
  },

  /**
   * caculate the great circle distance
   * @param {Object} lat1
   * @param {Object} lng1
   * @param {Object} lat2
   * @param {Object} lng2
   */

  getGreatCircleDistance(lat1, lng1, lat2, lng2) {
    var radLat1 = this.getRad(lat1);
    var radLat2 = this.getRad(lat2);
    var a = radLat1 - radLat2;
    var b = this.getRad(lng1) - this.getRad(lng2);
    var s =
      2 *
      Math.asin(
        Math.sqrt(
          Math.pow(Math.sin(a / 2), 2) +
          Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)
        )
      );
    s = s * EARTH_RADIUS;
    s = Math.round(s * 10000) / 10000.0;
    return s;
  },

  // 是否
  checkMobileSys() {
    var u = navigator.userAgent;
    if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
      // 安卓手机
      return 'Android';
      // return false
    } else if (u.indexOf('iPhone') > -1) {
      // 苹果手机
      return 'iPhone';
      // return true
    } else if (u.indexOf('iPad') > -1) {
      // iPad
      return 'iPad';
      // return false
    } else if (u.indexOf('Windows Phone') > -1) {
      // winphone手机
      return 'Windows Phone';
      // return false
    } else {
      return 'false';
    }
  },

  // 字符串占位符替换
  StringFormat() {
    if (arguments.length == 0) return null;
    var str = arguments[0];
    for (var i = 1; i < arguments.length; i++) {
      var re = new RegExp('\\{' + (i - 1) + '\\}', 'gm');
      str = str.replace(re, arguments[i]);
    }
    return str;
  },


  // 生成长度为L的随机字符串
  randomstring(L) {
    var s = '';
    var randomchar = function () {
      var n = Math.floor(Math.random() * 62);
      if (n < 10) return n; // 1-10
      if (n < 36) return String.fromCharCode(n + 55); // A-Z
      return String.fromCharCode(n + 61); // a-z
    };
    while (s.length < L) s += randomchar();
    return s;
  },

  // 获取url中指定参数的值
  getUrlParam(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)'); // 构造一个含有目标参数的正则表达式对象
    var r = window.location.search.substr(1).match(reg); // 匹配目标参数
    if (r != null) return decodeURI(r[2]);
    return null; // 返回参数值00000000000000000000
  },
  // 强制保留两位小数
  toDecimal2(x) {
    var f = parseFloat(x);
    if (isNaN(f)) {
      return false;
    }
    f = Math.round(x * 100) / 100;
    var s = f.toString();
    var rs = s.indexOf('.');
    if (rs < 0) {
      rs = s.length;
      s += '.';
    }
    while (s.length <= rs + 2) {
      s += '0';
    }
    return s;
  },

  // 除法函数,用来得到精确的除法结果
  // 说明：javascript的除法结果会有误差,在两个浮点数相除的时候会比较明显。这个函数返回较为精确的除法结果。
  // 调用：accDiv(arg1,arg2)
  // 返回值：arg1除以arg2的精确结果
  accDiv(arg1, arg2) {
    var t1 = 0;
    var t2 = 0;
    var r1;
    var r2;
    try {
      var arg1Array = arg1.toString().split('.');

      t1 = (arg1Array[1] && arg1Array[1].length) || 0;
    } catch (e) {
      window.console.log(e);
    }
    try {
      var arg2Array = arg2.toString().split('.');
      t2 = (arg2Array[1] && arg2Array[1].length) || 0;
    } catch (e) {
      window.console.log(e);
    }
    r1 = Number(arg1.toString().replace('.', ''));
    r2 = Number(arg2.toString().replace('.', ''));
    return (r1 / r2) * Math.pow(10, t2 - t1);
  },

  // 乘法函数,用来得到精确的乘法结果
  // 说明：javascript的乘法结果会有误差,在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
  // 调用：accMul(arg1,arg2)
  // 返回值：arg1乘以 arg2的精确结果
  accMul(arg1, arg2) {
    var m = 0;
    var s1 = arg1.toString();
    var s2 = arg2.toString();
    try {
      var arg1Array = arg1.toString().split('.');
      m += (arg1Array[1] && arg1Array[1].length) || 0;
    } catch (e) {
      window.console.log(e);
    }
    try {
      var arg2Array = arg2.toString().split('.');
      m += (arg2Array[1] && arg2Array[1].length) || 0;
    } catch (e) {
      window.console.log(e);
    }
    return (
      (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
      Math.pow(10, m)
    );
  },

  // 加法函数,用来得到精确的加法结果
  // 说明：javascript的加法结果会有误差,在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
  // 调用：accAdd(arg1,arg2)
  // 返回值：arg1加上arg2的精确结果
  accAdd(arg1, arg2) {
    var r1, r2, m;
    try {
      r1 = arg1.toString().split('.')[1].length;
    } catch (e) {
      r1 = 0;
    }
    try {
      r2 = arg2.toString().split('.')[1].length;
    } catch (e) {
      r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    return (this.accMul(arg1, m) + this.accMul(arg2, m)) / m;
  },

  // 减法函数,用来得到精确的减法结果
  // 说明：javascript的加法结果会有误差,在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
  // 调用：accSub(arg1,arg2)
  // 返回值：arg1减去arg2的精确结果
  accSub(arg1, arg2) {
    var r1, r2, m;
    try {
      r1 = arg1.toString().split('.')[1].length;
    } catch (e) {
      r1 = 0;
    }
    try {
      r2 = arg2.toString().split('.')[1].length;
    } catch (e) {
      r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    return (this.accMul(arg1, m) - this.accMul(arg2, m)) / m;
  },

  /**
   * 1. type 类型判断
   */
  isString(o) {
    // 是否字符串
    return Object.prototype.toString.call(o).slice(8, -1) === 'String';
  },

  isNumber(o) {
    // 是否数字
    return Object.prototype.toString.call(o).slice(8, -1) === 'Number';
  },

  isObj(o) {
    // 是否对象
    return Object.prototype.toString.call(o).slice(8, -1) === 'Object';
  },
  isEmptyObject(o) {
    return Object.keys(o).length === 0;
  },

  isArray(o) {
    // 是否数组
    return Object.prototype.toString.call(o).slice(8, -1) === 'Array';
  },

  isDate(o) {
    // 是否时间
    return Object.prototype.toString.call(o).slice(8, -1) === 'Date';
  },

  isBoolean(o) {
    // 是否boolean
    return Object.prototype.toString.call(o).slice(8, -1) === 'Boolean';
  },

  isFunction(o) {
    // 是否函数
    return Object.prototype.toString.call(o).slice(8, -1) === 'Function';
  },

  isNull(o) {
    // 是否为null
    return Object.prototype.toString.call(o).slice(8, -1) === 'Null';
  },

  isUndefined(o) {
    // 是否undefined
    return Object.prototype.toString.call(o).slice(8, -1) === 'Undefined';
  },

  isFalse(o) {
    if (!o || o === 'null' || o === 'undefined' || o === 'false' || o === 'NaN') { return true; }
    return false;
  },

  isTrue(o) {
    return !this.isFalse(o);
  },

  loadScript(url, callback) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    if (typeof callback !== 'undefined') {
      if (script.readyState) {
        script.onreadystatechange = function () {
          if (
            script.readyState == 'loaded' ||
            script.readyState == 'complete'
          ) {
            script.onreadystatechange = null;
            callback();
          }
        };
      } else {
        script.onload = function () {
          callback();
        };
      }
    }
    script.src = url;
    document.body.appendChild(script);
  },
  wechatPay(paymsg) {
    return new Promise((resolve, reject) => {
      Wechat.isInstalled(
        function () {
          Wechat.sendPaymentRequest(
            paymsg,
            function () {
              resolve({ payState: true });
            },
            function (reason) {
              window.console.log('Failed: ' + reason);
              reject(reason);
            }
          );
        },
        function (reason) {
          window.console.log('Failed: ' + reason);
          reject(reason);
        }
      );
    });
  },
  /* 支付后手动刷新 */
  CheckPayfor(ordernumber,userId,param){
    return new Promise((resolve,reject)=>{
      axios.post('https://x6.goeasy.cn/cli/client/'+param,{
        ordernumber: ordernumber,
        userId: userId
      }).then(res=>{
        resolve(res)
      }).catch(error=>{
        reject(error)
      })
    })
  },
  /* 支付宝web端支付 */
  AliPay_Web(ordernumber,userId){
    return new Promise((resolve,reject)=>{
      axios.post("https://x6.goeasy.cn/cli/client/Web_AliPay",{
          type: "WEB",
          ordernumber: ordernumber,
          userId: userId
        }
      ).then(res=>{
        resolve(res)
      }).catch(error=>{
        reject(error)
      })
    })
  },
  /* 微信web端支付 */
  WXPay_Web(ordernumber,userId){
    return new Promise((resolve,reject)=>{
      axios.post("https://x6.goeasy.cn/cli/client/Web_GetWechatPay",{
          type: "WEB",
          ordernumber: ordernumber,
          userId: userId
        }
      ).then(res=>{
        resolve(res)
      }).catch(error=>{
        reject(error)
      })
    })
  },
  aliPay(paymsg) {
    const payInfo = paymsg.replace(/\&amp\;/g, '&');
    return new Promise((resolve, reject) => {
      cordova.plugins.alipay.payment(
        payInfo,
        function success(state) {
          resolve(state);
          // if (e.resultStatus == '8000') {
          //   $("#promotview_tishi p").text("正在处理中");
          // } else if (e.resultStatus == '9000') {
          //   $("#promotview_tishi p").text("订单支付成功");
          // } else if (e.resultStatus == '9000') {
          //   $("#promotview_tishi p").text("请去服务端验证支付结果");
          // }
        },
        function error(e) {
          reject(e);
          // if (e.resultStatus == '4000') {
          //   $("#promotview_tishi p").text("订单支付失败");
          // } else if (e.resultStatus == '6001') {
          //   $("#promotview_tishi p").text("用户中途取消");
          // } else if (e.resultStatus == '6002') {
          //   $("#promotview_tishi p").text("网络连接出错");
          // } else if (e.resultStatus == '9000') {
          //   $("#promotview_tishi p").text("请去服务端验证支付结果");
          // }
        }
      );
    });
  },

  /**
   * 中国正常GCJ02坐标---->百度地图BD09坐标
   * 腾讯地图用的也是GCJ02坐标
   * @param double $lat 纬度
   * @param double $lng 经度
   */
  Convert_GCJ02_To_BD09($lat, $lng) {
    const $x_pi = (3.14159265358979324 * 3000.0) / 180.0;
    const $x = $lng;
    const $y = $lat;
    const $z = Math.sqrt($x * $x + $y * $y) + 0.00002 * Math.sin($y * $x_pi);
    const $theta = Math.atan2($y, $x) + 0.000003 * Math.cos($x * $x_pi);
    $lng = $z * Math.cos($theta) + 0.0065;
    $lat = $z * Math.sin($theta) + 0.006;
    return { lat: $lat, lng: $lng };
  },
  /**
   * 百度地图BD09坐标---->中国正常GCJ02坐标
   * 腾讯地图用的也是GCJ02坐标
   * @param double $lat 纬度
   * @param double $lng 经度
   * @return array();
   */
  Convert_BD09_To_GCJ02($lat, $lng) {
    const $x_pi = (3.14159265358979324 * 3000.0) / 180.0;
    const $x = $lng - 0.0065;
    const $y = $lat - 0.006;
    const $z = Math.sqrt($x * $x + $y * $y) - 0.00002 * Math.sin($y * $x_pi);
    const $theta = Math.atan2($y, $x) - 0.000003 * Math.cos($x * $x_pi);
    $lng = $z * Math.cos($theta);
    $lat = $z * Math.sin($theta);
    return { lat: $lat, lng: $lng };
  }
};

/**
 * 函数防抖 (只执行最后一次点击)
 * @param fn
 * @param delay
 * @returns {Function}
 * @constructor
 */
export const Debounce = function (fn, t) {
  const delay = t || 500;
  let timer;
  return function () {
    const args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      timer = null;
      fn.apply(this, args);
    }, delay);
  };
};

/**
 * 函数节流
 * @param fn
 * @param interval
 * @returns {Function}
 * @constructor
 */
export const Throttle = function (fn, t) {
  let last;
  let timer;
  const interval = t || 500;
  return function () {
    const args = arguments;
    const now = +new Date();
    if (last && now - last > interval) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        last = now;
        fn.apply(this, args);
      }, interval);
    } else {
      last = now;
      fn.apply(this, args);
    }
  };
};
